__turbopack_context__.v({
  "add-room": "passenger-room-count-tour-module-scss-module__1lqWfW__add-room",
  "delete": "passenger-room-count-tour-module-scss-module__1lqWfW__delete",
  "dropwdown-box": "passenger-room-count-tour-module-scss-module__1lqWfW__dropwdown-box",
  "dropwdown-item": "passenger-room-count-tour-module-scss-module__1lqWfW__dropwdown-item",
  "end-icon": "passenger-room-count-tour-module-scss-module__1lqWfW__end-icon",
  "error": "passenger-room-count-tour-module-scss-module__1lqWfW__error",
  "footer": "passenger-room-count-tour-module-scss-module__1lqWfW__footer",
  "header": "passenger-room-count-tour-module-scss-module__1lqWfW__header",
  "label": "passenger-room-count-tour-module-scss-module__1lqWfW__label",
  "label-selected-value": "passenger-room-count-tour-module-scss-module__1lqWfW__label-selected-value",
  "list": "passenger-room-count-tour-module-scss-module__1lqWfW__list",
  "main": "passenger-room-count-tour-module-scss-module__1lqWfW__main",
  "mini-popover": "passenger-room-count-tour-module-scss-module__1lqWfW__mini-popover",
  "none-option": "passenger-room-count-tour-module-scss-module__1lqWfW__none-option",
  "passenger-count": "passenger-room-count-tour-module-scss-module__1lqWfW__passenger-count",
  "select": "passenger-room-count-tour-module-scss-module__1lqWfW__select",
  "select-box": "passenger-room-count-tour-module-scss-module__1lqWfW__select-box",
  "title": "passenger-room-count-tour-module-scss-module__1lqWfW__title",
});
